import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.new');
import { OnInit, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { UploadService } from "../../libs/upload.service.ts";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-new',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.new/view.scss */
/* File Upload Component Styles */
@layer utilities {
  .animation-delay-2000 {
    animation-delay: 2s;
  }
  .animation-delay-4000 {
    animation-delay: 4s;
  }
}
/* Custom scrollbar for file grid */
.file-grid::-webkit-scrollbar {
  width: 6px;
}

.file-grid::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.file-grid::-webkit-scrollbar-thumb {
  background: rgba(147, 51, 234, 0.5);
  border-radius: 3px;
}

.file-grid::-webkit-scrollbar-thumb:hover {
  background: rgba(147, 51, 234, 0.7);
}

/* Smooth transitions for all interactive elements */
* {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Enhanced hover effects */
.group:hover .group-hover\:opacity-100 {
  opacity: 1;
}

/* File preview image styles */
img {
  object-fit: cover;
  transition: transform 0.3s ease;
}

.group:hover img {
  transform: scale(1.05);
}

/* Button press effect */
button:active {
  transform: scale(0.95);
}

/* Drag and drop visual feedback */
.drag-over {
  background: rgba(147, 51, 234, 0.1);
  border-color: rgb(147, 51, 234);
  transform: scale(1.02);
}

/* Loading animation for file processing */
@keyframes pulse-slow {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.4;
  }
}
.animate-pulse-slow {
  animation: pulse-slow 3s ease-in-out infinite;
}`],
})
export class ComponentNewComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( NgZone)  private zone: NgZone,@Inject( UploadService)  private uploadService: UploadService,@Inject( Router)  private router: Router) { }
    public selectedFiles: File[] = [];
    public isDragging: boolean = false;


    public getBadgeColor(file: File): string {
        const name = file.name.toLowerCase();
        if (name.endsWith('.pdf')) return 'bg-blue-600';
        if (name.endsWith('.xlsx')) return 'bg-green-600';
        if (name.endsWith('.doc') || name.endsWith('.docx')) return 'bg-indigo-600';
        if (name.endsWith('.ppt') || name.endsWith('.pptx')) return 'bg-yellow-500';
        if (name.endsWith('.txt')) return 'bg-gray-600';
        if (name.endsWith('.hwp')) return 'bg-purple-600';
        return 'bg-slate-500';
    }

    public getIconClass(file: File): string {
        const name = file.name.toLowerCase();
        if (name.endsWith('.pdf')) return 'fas fa-file-pdf text-blue-500';
        if (name.endsWith('.xlsx') || name.endsWith('.xls')) return 'fas fa-file-excel text-green-500';
        if (name.endsWith('.doc') || name.endsWith('.docx')) return 'fas fa-file-word text-blue-400';
        if (name.endsWith('.ppt') || name.endsWith('.pptx')) return 'fas fa-file-powerpoint text-yellow-500';
        if (name.endsWith('.txt')) return 'fas fa-file-alt text-gray-400';
        if (name.endsWith('.hwp')) return 'fas fa-file-word text-purple-500';
        return 'fas fa-file text-white';
    }

    public getFileExt(file: File): string {
        const name = file.name;
        const parts = name.split('.');
        const ext = parts.length > 1 ? parts.pop() : 'FILE';
        return ext?.toUpperCase() || 'FILE';
    }


    public async handleFileSelect(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
            this.addFiles(input.files);
            input.value = '';
        }
        await this.service.render();
    }

    private addFiles(files: FileList) {
        for (const file of Array.from(files)) {
            if (!this.selectedFiles.some(f => f.name === file.name)) {
                this.selectedFiles.push(file);
            }
        }
    }

    public removeFile(index: number) {
        this.selectedFiles.splice(index, 1);
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();

        document.addEventListener("dragover", this.handleGlobalDragOver.bind(this));
        document.addEventListener("dragleave", this.handleGlobalDragLeave.bind(this));
        document.addEventListener("drop", this.handleGlobalDrop.bind(this));
    }

    public async handleGlobalDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragging = true;
        await this.service.render();
    }

    public async handleGlobalDragLeave(event: DragEvent) {
        if (event.relatedTarget === null) {
            this.isDragging = false;
            await this.service.render();
        }
    }

    public async handleGlobalDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;
        if (event.dataTransfer?.files.length) {
            this.addFiles(event.dataTransfer.files);
        }
        await this.service.render();
    }

    public async startAnalysis() {
        if (this.selectedFiles.length === 0) return;

        const formData = new FormData();
        for (const file of this.selectedFiles) {
            formData.append("files[]", file);
        }

        const url = wiz.url("create_session_with_upload");
        const response = await fetch(url, {
            method: "POST",
            body: formData
        });

        const json = await response.json();
        if (response.ok) {
            const sessionId = json.data.session_id;
            await this.router.navigate(["/report"], {
                queryParams: { session_id: sessionId }
            });
        } else {
            await this.service.alert.show({ message: json });
        }
    }

}

export default ComponentNewComponent;